import AxiosFunctions from "./axiosFunctions";

/* all URI to API */
const uri = {
  getRolesUri: "/seguridad/roles",
  getPermisosUri: "/seguridad/permisos",
  savePermisosUri: "/seguridad/permisos/asignar-desasignar",
  getCiudadesUri: "/seguridad/ciudades?select=true",
  getListasUri: "/lista",
};

export default {
  /*
   *
   * Roles
   *
   */
  getRoles: async () => {
    return await AxiosFunctions.get(uri.getRolesUri, {});
  },

  saveRoles: async (data) => {
    return await AxiosFunctions.post(uri.getRolesUri, data);
  },

  editRoles: async (data) => {
    let id = data[0];
    let params = { name: data[1], guard_name: data[2], empresa_id: data[3] };
    return await AxiosFunctions.patch(uri.getRolesUri + "/" + id, params);
  },

  deleteRoles: async (id) => {
    return await AxiosFunctions.delete(uri.getRolesUri + "/" + id, {});
  },

  /*
   *
   * Permisos
   *
   */
  getPermisos: async (id) => {
    return await AxiosFunctions.get(uri.getPermisosUri + "/" + id, {});
  },

  savePermisos: async (data) => {
    return await AxiosFunctions.post(uri.savePermisosUri, data);
  },

  /*
   *
   * Operaciones
   *
   */

  getCiudades: async () => {
    return await AxiosFunctions.get(uri.getCiudadesUri, {});
  },

  getListas: async (id) => {
    return await AxiosFunctions.get(uri.getListasUri + "/" + id, {});
  },
};
